export const defaultStringTransition = {
  type: "spring",
  stiffness: 550,
  damping: 60,
} as any; // any because for some reason chakra cannot accept non-responsive values for transition props
